































// Importing components
import BaseAlertList from '@/ui/BaseAlertList.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import TheTownSelect from '@/components/addresses/TheTownSelect.vue';

export default {
    name: 'TheFormAddressesCart',
    components: {
        TheTownSelect,
        BaseAlertList,
        BaseInputField,
    },
    props: {
        address: Object,
        errors: Array,
    },
    data() {
        return {
            ekatte: String(),
        };
    },
    methods: {},
};
